import React, { useCallback, useState } from 'react';

import AttachDocuments from '@components/common/AttachDocuments';

import { useMutateCreateUrlForRequestDocument } from '@hooks/assets/useMutateCreateUrlForRequestDocument';

import { IAssetFile } from '@interfaces/assets/asset';

import {
	acceptedFileTypes,
	fileErrors,
	MAX_BYTES,
	supportsText,
} from './constants';

interface IAttachAssetDocumentsProps {
	toggleUploadFilesModal: () => void;
	handleUploadFiles: (file: IAssetFile) => void;
	setIsDirtyForm: (isDirty: boolean) => void;
	onClose: () => void;
	requestId: string;
}

const AttachRequestDocuments = ({
	toggleUploadFilesModal,
	handleUploadFiles,
	setIsDirtyForm,
	onClose,
	requestId,
}: IAttachAssetDocumentsProps) => {
	const [uploadedFiles, setUploadedFiles] = useState<IAssetFile[]>([]);

	const {
		createUploadUrlAttachment,
		progress,
	} = useMutateCreateUrlForRequestDocument({ setUploadedFiles, requestId, setIsDirtyForm });

	const clearUploadedFiles = () => setUploadedFiles([]);

	const onUploadClickHandler = useCallback(() => {
		if (!uploadedFiles.length) return;

		handleUploadFiles(uploadedFiles[0]);
		toggleUploadFilesModal();
	}, [uploadedFiles, handleUploadFiles, toggleUploadFilesModal]);

	return (
		<AttachDocuments
			acceptedFileTypes={acceptedFileTypes}
			createUploadUrlAttachment={createUploadUrlAttachment as any}
			fileErrors={fileErrors}
			fileRejectionErrorHandler={clearUploadedFiles}
			isMultipleFiles={false}
			maxBytes={MAX_BYTES}
			onDropAcceptedHandler={clearUploadedFiles}
			onUploadClickHandler={onUploadClickHandler}
			progress={progress}
			supportsText={supportsText}
			toggleUploadFilesModal={onClose}
			uploadedFilesLength={uploadedFiles.length}
		/>
	);
};

export default AttachRequestDocuments;
